"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const specified_1 = require("specified");
exports.placePredictionsResponseSpec = specified_1.Type.object({
    name: specified_1.Type.string,
    places: specified_1.Type.array(specified_1.Type.array(specified_1.Type.string))
});
exports.coordinatesResponseSpec = specified_1.Type.object({
    address: specified_1.Type.string,
    coordinates: specified_1.Type.object({
        lat: specified_1.Type.number,
        lng: specified_1.Type.number
    })
});
//# sourceMappingURL=models.js.map